module.exports = __webpack_public_path__ + "img/mail-error.3ad253e4.png";